<template>
  <b-container>
    <Loading v-if="isLoading" :active.sync="isLoading"></Loading>
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol cols="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-indocyber.png">
        </CCol>
      </CRow>
      <CRow>
        <CCol cols="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            Login
          </h1>
        </CCol>
      </CRow>
      <div class="content">
        <CRow>
          <div class="col-12">
            <label class="textarea-input" for="input-service-id">Original Document:</label>
            <input ref="originaldoc" class="mb-2 sm-input" type="file" accept=".doc, .docx, .pdf" @change="onInputOriginalDoc">
          </div>
          <div class="col-12 mt-3">
            <label class="textarea-input" for="input-service-id">Document(s) to Compare:</label>
            <input ref="comparedoc" class="mb-2 sm-input" type="file" multiple accept=".doc, .docx, .pdf" @change="onInputCompareDocs">
          </div>
          <CCol cols="12" class="form-button text-right mt-4">
            <div class="sm-nav-wrapper">
              <div class="bottom-router">
                <router-link :to="{}" @click.native="onClickSubmit" class="btn">
                  <span><img src=""></span>Login
                </router-link>
              </div>
            </div>
          </CCol>
        </CRow>
      </div>
      <CRow class="mt-5" v-if="resultCompare.length > 0">
        <CCol cols="12" class="d-flex justify-content-center my-2">
          <h4 class="greetings-underline">
            COMPARISON RESULT
          </h4>
        </CCol>
      </CRow>
      <div v-if="resultCompare.length > 0" class="content">
        <CRow>
          <CCol cols="12">
            <b-tabs v-model="activeTab" class="comparison-tabs" nav-class="comparison-tabs-list">
              <b-tab v-for="(doc, index) in resultCompare" :key="'result-doc-' + index" :title="'Result ' + (index+1)" title-link-class="comparison-tab-header">
                <template #title>
                  <span v-if="doc.isLoading"><b-spinner class="comparison-tab-spinner"></b-spinner> Loading...</span>
                  <span v-else>Result {{ index + 1}}</span>
                </template>
                <div class="mt-4" v-if="doc.isLoading || doc.error.length > 0">
                  <div v-if="doc.isLoading" class="text-center">
                    <b-spinner class="comparison-result-spinner" variant="primary"></b-spinner>
                  </div>
                  <div v-else-if="doc.error.length > 0">
                    <CRow>
                      <CCol cols="12">
                        <h6>Original Document: {{ doc.file1 }}</h6>
                        <h6>Compared Document: {{ doc.file2 }}</h6>
                      </CCol>
                    </CRow>
                    <hr>
                    <div class="text-center my-2">
                      <h3 class="comparison-result-error">
                        ANALYSIS FAILED: <br>
                        {{ doc.error }}
                      </h3>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <CRow class="mt-4">
                    <CCol cols="12" class="comparison-result-desc">
                      <h6>Original Document: {{ doc.file1 }}</h6>
                      <h6>Compared Document: {{ doc.file2 }}</h6>
                      <h6 v-if="doc.message">Analysis Result: {{ doc.message }}</h6>
                      <a v-if="doc.url" :href="$fileUrl + doc.url" target="_blank">Download Comparison Results</a>
                    </CCol>
                  </CRow>
                  <hr>
                  <CRow class="mb-2">
                    <CCol cols="12" class="d-flex justify-content-center my-2">
                      <h3 class="page-greetings">
                        Result {{ doc.score }}% match
                      </h3>
                    </CCol>
                  </CRow>
                  <div v-for="(page, i) in doc.pages" :key="'result-page-' + i" class="mb-4">
                    <div class="comparison-result-page">
                      <h4>Page {{ i + 1 }}</h4>
                      <h5>{{ page.score }}% match</h5>
                      <!-- <p>{{ page.status }}</p> -->
                    </div>
                    <b-table 
                      v-if="page.differences.length > 0"
                      thClass="hehek"
                      :fields="fields"
                      :items="page.differences"
                      bordered small
                    >
                      <template #cell(index)="row">
                        <span>{{ row.index + 1 }}</span>
                      </template>
                      <template #cell(before)="row">
                        ...<span v-html="row.item.before"></span>...
                      </template>
                      <template #cell(after)="row">
                        ...<span v-html="row.item.after"></span>...
                      </template>
                    </b-table>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </CCol>
        </CRow>
      </div>
      <TheFooter></TheFooter>
    </b-card>
      <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
        <div slot="body">
          <label>{{errorLabel}}</label>
          <div class="btn-footer">
            <button class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
          </div>
        </div>
      </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter';
import Modal from  '../Modal';
// import moment from 'moment';

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      isLoading: false,
      showErrorModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      originalDoc: null,
      compareDocs: [],
      fields: [
          { key: 'index', label: '#', thStyle: { width: '5%' } },
          { key: 'before', label: 'Before (Original)', thStyle: { width: '47.5%' } },
          { key: 'after', label: 'After (Scanned)', thStyle: { width: '47.5%' } },
      ],
      resultCompare: [],
      activeTab: 0,
    }
  },
  methods: {
    onInputOriginalDoc(e){
      this.originalDoc = e.target.files[0]
    },
    onInputCompareDocs(e){
      this.compareDocs = e.target.files
    },
    async onClickSubmit(){

      this.$router.push({ name: "Main"})

      // this.isLoading = true

      // this.resultCompare = []

      // for(let i = 0; i < this.compareDocs.length; i++){
      //   this.resultCompare[i] = {
      //     isLoading: true,
      //     error: "",
      //     file1:this.originalDoc.name, 
      //     file2:this.compareDocs[i].name, 
      //     message: "",
      //     score:0, 
      //     url:"", 
      //     pages:[] 
      //   }
      // }
      
      // for(let i = 0; i < this.compareDocs.length; i++){
      //   await this.analyzeDoc(i)
      // }
    },
    async analyzeDoc(i){
      
      let url = "/comparison"
      
      // let data = {
      //   text: this.inputText
      // }
      let payload = new FormData()
      payload.set('file_1', this.originalDoc)
      payload.set('file_2', this.compareDocs[i])

      await this.$axios.post(url, payload).then((response) => {
        if (response.status === 200 && response.data.success){
          let results = response.data
          console.log(results)
          if(results.data) {
            let tempFileUrl = results.data.url_pdf.split("/")
            tempFileUrl = tempFileUrl[tempFileUrl.length-1]
            if(!results.data.changes || results.data.changes.length <= 0) {
              this.resultCompare[i].isLoading = false
              this.resultCompare[i].file1 = results.data.file_1_name
              this.resultCompare[i].file2 = results.data.file_2_name
              this.resultCompare[i].message = results.message
              this.resultCompare[i].score = results.data.score
              this.resultCompare[i].url = tempFileUrl
            }
            else{
              // loop per page
              let page_rows = []
              results.data.changes.forEach((function(page, index) {
                if(page.changes === null || page.changes.length == 0) {
                  page_rows.push({ status:"MATCH", page:page.page_no, score:page.score, differences:[] })
                }
                else {
                  // loop per sentences with difference
                  let row_differences = []
                  page.changes.forEach(function(row, i) {
                    let before_sentence = ""
                    let after_sentence = ""
                    // loop per words in detected sentences
                    row.words.forEach(function(current_word, j) {
                      if(current_word.type == "word") {
                        if(page.page_blank == "before"){
                          after_sentence += current_word.word
                        }
                        else if(page.page_blank == "after"){
                          before_sentence += current_word.word
                        }
                        else {
                          before_sentence += current_word.word
                          after_sentence += current_word.word
                        }
                      }
                      else if(current_word.type == "subtract") {
                        // before_sentence += `<span class="bg-danger correction-sub">` +current_word.word + `</span>`
                        before_sentence += `<span class="bg-danger correction-sub">` +current_word.word + `</span>`
                      }
                      else if(current_word.type == "add") {
                        // after_sentence += `<span class="bg-success correction-add">` +current_word.word + `</span>`
                        after_sentence += `<span class="bg-success correction-add">` +current_word.word + `</span>`
                      }
                    })
                    if(page.page_blank == "before"){
                      after_sentence = row.sentence_before + after_sentence + row.sentence_after
                    }
                    else if(page.page_blank == "after"){
                      before_sentence = row.sentence_before + before_sentence + row.sentence_after
                    }
                    else {
                      before_sentence = row.sentence_before + before_sentence + row.sentence_after
                      after_sentence = row.sentence_before + after_sentence + row.sentence_after
                    }
                    row_differences.push({ index: i+1, before: before_sentence, after: after_sentence })
                    // rows += `<tr><td>` + (i + 1) + `</td><td>...` + before_sentence + `...</td><td>...` + after_sentence + `...</td></tr>`
                  })
                  page_rows.push({ status:"NOT MATCH", page:page.page_no, score:page.score, differences:row_differences })
                }
              }))
              this.resultCompare[i].isLoading = false
              this.resultCompare[i].file1 = results.data.file_1_name
              this.resultCompare[i].file2 = results.data.file_2_name
              this.resultCompare[i].message = results.message
              this.resultCompare[i].score = results.data.score
              this.resultCompare[i].url = tempFileUrl
              this.resultCompare[i].pages = page_rows
            }
          }
          else {
            this.resultCompare[i].message = results.message
            this.resultCompare[i].score = 100
            this.resultCompare[i].isLoading = false
          }
        }
        else {
          if(!response.data.success && response.data.message) this.resultCompare[i].error = response.data.message
          else this.resultCompare[i].error = "Terjadi kesalahan pada server. Silahkan coba lagi."
          this.resultCompare[i].isLoading = false
          // this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
          // this.errorReload = false
          // this.showErrorModal = true
        }
      })
      // Promise.all([runSummary, runNER]).then(() => {
      //   // this.inputText = ""
      // })
      .catch(error => {
        if(error.response) this.resultCompare[i].error = error.response.data.reason
        else this.resultCompare[i].error = "Terjadi kesalahan pada server. Silahkan coba lagi."
        this.resultCompare[i].isLoading = false
        // if(error.response) this.errorLabel = error.response.data.reason
        // else this.errorLabel = "Terjadi kesalahan pada server. Silahkan coba lagi."
        // this.errorReload = false
        // this.showErrorModal = true
      })
      .finally(() => {
        this.$forceUpdate()
      })
    }
  }
}
</script>